import template from './employee_details_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EmployeDetailsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeDetailsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeDetailsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeDetailsHelp',
	dialog_class: EmployeDetailsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_details_help',
	provider: 'ps'
};
